import { render, staticRenderFns } from "./my_like_house.vue?vue&type=template&id=2521d3cc&scoped=true&"
import script from "./my_like_house.vue?vue&type=script&lang=js&"
export * from "./my_like_house.vue?vue&type=script&lang=js&"
import style0 from "./my_like_house.vue?vue&type=style&index=0&id=2521d3cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2521d3cc",
  null
  
)

export default component.exports